import { CheckCircleIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

import { useMovimentacaoFundos } from '../hooks/useMovimentacaoFundos';
import { LayoutMovimentacaoFundos } from '../layouts/LayoutMovimentacaoFundos';

export const Conclusao = () => {
  const navigate = useNavigate();

  const fundContent = JSON.parse(localStorage.getItem('originFundSelected'));

  return (
    <LayoutMovimentacaoFundos
      navigate={() => {
        //
      }}
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-w-full tw-max-w-6xl tw-pt-[70px] tw-pb-[70px] tw-bg-white tw-rounded-lg tw-shadow-md tw-mb-5">
        <CheckCircleIcon w="74px" h="74px" color="#006217" />
        <p className="tw-text-center tw-text-[#006217] tw-mt-[30px] tw-font-bold tw-text-[1.5rem] tw-leading-[2rem] tw-w-full tw-max-w-[438px]">
          Esta movimentação foi enviada para assinatura do cliente com sucesso!
        </p>
        <button
          className="tw-mt-[40px] tw-w-[298px] tw-h-[34px] tw-bg-[#FA6B25] tw-text-[#FFFFFF] tw-font-bold tw-focus:outline-none tw-focus:shadow-outline tw-border-2 tw-border-[#FA6B25] tw-rounded-[7px]"
          onClick={() => {
            navigate(
              '/corretor/previdencia-individual/movimentacao-fundos/analitico-proposta'
            );
          }}
        >
          Movimentar outro fundo
        </button>
        <button
          className="tw-mt-[20px] tw-w-[298px] tw-h-[34px] tw-bg-[#001E64] tw-text-[#FFFFFF] tw-font-bold tw-focus:outline-none tw-focus:shadow-outline tw-border-2 tw-border-[#001E64] tw-rounded-[7px]"
          onClick={() => {
            // localStorage.clear();
            if (process.env.NODE_ENV === 'production') {
              window.open('https://corretor.sulamericaseguros.com.br');
            } else {
              window.open('http://portalcorretord.sulamerica.br');
            }
          }}
        >
          Encerrar sessão
        </button>
      </div>
    </LayoutMovimentacaoFundos>
  );
};
